// @ts-strict-ignore
import styled from "styled-components";

export const BreadContainer = styled.ol`
  display: flex;
  list-style-type: none;
  padding-left: 0;
`;
